<template>
    <div class="article-faqs-tile-partner">
        <p>
            We rotate partners throughout the class, so you don't need to bring a partner. Lot's of our dancers attend
            the events on their own and everyone is really friendly - so you'll soon get chatting to people.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleFaqsTilePartner',
};
</script>
